'use strict';

exports.__esModule = true;
exports.default = EmbeddedPost;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmbeddedPost(props) {
  var className = props.className,
      href = props.href,
      width = props.width,
      showText = props.showText,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-post',
        'data-href': href,
        'data-width': width,
        'data-show-text': showText
      },
      children
    )
  );
}

EmbeddedPost.defaultProps = {
  width: undefined,
  showText: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=EmbeddedPost.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/EmbeddedPost.js
// module id = 998
// module chunks = 198517197184460